import getFetcher from 'api/utils/getFetcher';
import { useMemo } from 'react';
import useSWR from 'swr';
import type { LegacyPool } from 'types/legacyDashboard';

export interface PoolsResult {
  success: true;
  data?: Array<LegacyPool>;
  size: number;
  limit: number;
  lastid: number;
  continues: boolean;
}

export interface PoolsError {}

interface UsePoolsProps {
  organizationId?: OrgId;
  canLoad?: boolean;
}

const usePools = ({ organizationId, canLoad = true }: UsePoolsProps) => {
  const queryParams = new URLSearchParams({
    orgid: organizationId?.toString() ?? '',
    enabled: '1',
    limit: '1000',
  });

  const url = canLoad ? `${process.env.VITE_API_ROOT}/pools?${queryParams}` : null;

  const { data, error, isLoading, mutate, isValidating } = useSWR<PoolsResult, PoolsError>(
    url,
    getFetcher
  );

  const pools: Array<LegacyPool> = useMemo(() => {
    if (!data?.data) {
      return [];
    }

    return data.data;
  }, [data]);

  return {
    pools,
    error,
    isLoading,
    mutate,
    isValidating,
  };
};

export default usePools;
